<template>
    <div class="home">

        <h1>Verwahrentgelte für Einlagen im Firmenkundengeschäft müssen nicht sein.</h1>
        <p>Den Verwahrentgeltsatz für Ihre Einlagen können Sie bei uns selbst bestimmen. Dieser liegt aktuell zwischen
            plus 0,10 % p.a. und minus 0,50 % p.a. und ermittelt sich durch das
            Verhältnis Ihrer Einlagen zu Ihrem Gesamtvolumen (Einlagen<sup>(1)</sup>) + Kredite<sup>(1)</sup> + Sonstige
            Anlagen<sup>(2)</sup>). Zusätzlich
            erhalten Sie pro VR Business Konto einen Einlagen-Freibetrag, der sich nach der Wahl Ihres VR Business
            Kontomodells richtet.
        </p>


        <div class="columnwrapper">
            <div style="margin-top: 20px" class="column">
                <h2>Ihr Finanzstatus bei uns</h2>

                <div class="formattedInputs"><label for="Einlagen">Einlagen<sup>(1)</sup>

                    <svg style="width:16px;height:16px;fill:white;cursor:pointer;margin-left: 6px"
                         @click="EinlagenHinweis = true"
                         stroke-miterlimit="10"
                         color-interpolation="auto" viewBox="0 0 230.344 230.203">
                        <path d="M230.344 115.172q0 47.953-33.61 81.492-33.609 33.54-81.562 33.54-47.953 0-81.563-33.54Q0 163.125 0 115.172t33.61-81.563Q67.218 0 115.171 0q47.953 0 81.562 33.61 33.61 33.609 33.61 81.562zm-18.844 0q0-40.219-28.055-68.344-28.054-28.125-68.273-28.125-40.219 0-68.344 28.125-28.125 28.125-28.125 68.344 0 40.219 28.125 68.273Q74.953 211.5 115.172 211.5q40.219 0 68.273-28.055 28.055-28.054 28.055-68.273zm-72.703-59.344q0 9.422-7.031 15.75-7.032 6.328-16.594 6.328-9.563 0-16.594-6.328-7.031-6.328-7.031-15.75t7.031-15.75q7.031-6.328 16.594-6.328 9.562 0 16.594 6.328 7.03 6.328 7.03 15.75zm-4.36 145.406H95.767V91.547h38.671z"
                              stroke="none"/>
                    </svg>
                </label>
                    <vue-numeric
                            id="Einlagen"
                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="€"
                            currency-symbol-position="suffix"
                            separator="."
                            v-model.number="Einlagen"></vue-numeric>
                </div>
                <modal v-if="EinlagenHinweis" @close="EinlagenHinweis = false">
                    <h3 slot="header">Einlagen</h3>
                    <div slot="body">

                        <p>
                            Zu Einlagen zählen Guthaben auf:
                        </p>
                        <ul>
                            <li>Giro- und Kontokorrentkonten</li>
                            <li>Festgelder</li>
                            <li>Sparkonten</li>
                            <li>Sparbriefe/ Termineinlagen</li>
                        </ul>

                        <div style="margin-top: 30px">
                            <button type="reset" class="button grey" @click="EinlagenHinweis = false"
                                    style="margin-right: 10px;color: #444">
                                Schließen
                            </button>
                        </div>
                    </div>
                    <div slot="footer">
                    </div>

                </modal>

                <div class="formattedInputs grey"><label>Kredite<sup>(1)</sup>
                    <svg style="width:16px;height:16px;fill:white;cursor:pointer;margin-left: 6px"
                         @click="KrediteHinweis = true"
                         stroke-miterlimit="10"
                         color-interpolation="auto" viewBox="0 0 230.344 230.203">
                        <path d="M230.344 115.172q0 47.953-33.61 81.492-33.609 33.54-81.562 33.54-47.953 0-81.563-33.54Q0 163.125 0 115.172t33.61-81.563Q67.218 0 115.171 0q47.953 0 81.562 33.61 33.61 33.609 33.61 81.562zm-18.844 0q0-40.219-28.055-68.344-28.054-28.125-68.273-28.125-40.219 0-68.344 28.125-28.125 28.125-28.125 68.344 0 40.219 28.125 68.273Q74.953 211.5 115.172 211.5q40.219 0 68.273-28.055 28.055-28.054 28.055-68.273zm-72.703-59.344q0 9.422-7.031 15.75-7.032 6.328-16.594 6.328-9.563 0-16.594-6.328-7.031-6.328-7.031-15.75t7.031-15.75q7.031-6.328 16.594-6.328 9.562 0 16.594 6.328 7.03 6.328 7.03 15.75zm-4.36 145.406H95.767V91.547h38.671z"
                              stroke="none"/>
                    </svg>
                </label>
                    <vue-numeric

                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="€"
                            currency-symbol-position="suffix"
                            separator="."
                            v-model.number="Kredite"></vue-numeric>
                </div>
                <modal v-if="KrediteHinweis" @close="KrediteHinweis = false">
                    <h3 slot="header">Kredite</h3>
                    <div slot="body">

                        <p>
                            Zu Krediten zählen Inanspruchnahmen von: </p>
                        <ul>
                            <li>Kontokorrentkrediten</li>
                            <li>bankeigenen Darlehen</li>
                            <li>Schwäbisch Hall - Bauspardarlehen</li>
                            <li>DZ Hyp / MHB - HypothekenDarlehen</li>
                            <li>Teambank - easyCredit</li>
                            <li>VR Smart Finanz - Leasing und Finanzierung</li>
                        </ul>

                        <div style="margin-top: 30px">
                            <button type="reset" class="button grey" @click="KrediteHinweis = false"
                                    style="margin-right: 10px;color: #444">
                                Schließen
                            </button>
                        </div>
                    </div>
                    <div slot="footer">
                    </div>

                </modal>

                <div class="formattedInputs grey"><label>Sonstige Anlagen<sup>(2)</sup>
                    <svg style="width:16px;height:16px;fill:white;cursor:pointer;margin-left: 6px"
                         @click="DepotHinweis = true"
                         stroke-miterlimit="10"
                         color-interpolation="auto" viewBox="0 0 230.344 230.203">
                        <path d="M230.344 115.172q0 47.953-33.61 81.492-33.609 33.54-81.562 33.54-47.953 0-81.563-33.54Q0 163.125 0 115.172t33.61-81.563Q67.218 0 115.171 0q47.953 0 81.562 33.61 33.61 33.609 33.61 81.562zm-18.844 0q0-40.219-28.055-68.344-28.054-28.125-68.273-28.125-40.219 0-68.344 28.125-28.125 28.125-28.125 68.344 0 40.219 28.125 68.273Q74.953 211.5 115.172 211.5q40.219 0 68.273-28.055 28.055-28.054 28.055-68.273zm-72.703-59.344q0 9.422-7.031 15.75-7.032 6.328-16.594 6.328-9.563 0-16.594-6.328-7.031-6.328-7.031-15.75t7.031-15.75q7.031-6.328 16.594-6.328 9.562 0 16.594 6.328 7.03 6.328 7.03 15.75zm-4.36 145.406H95.767V91.547h38.671z"
                              stroke="none"/>
                    </svg>
                </label>
                    <vue-numeric


                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="€"
                            currency-symbol-position="suffix"
                            separator="."
                            v-model.number="Depot"></vue-numeric>
                </div>
                <modal v-if="DepotHinweis" @close="DepotHinweis = false">
                    <h3 slot="header">Sonstige Anlagen</h3>
                    <div slot="body">
                        <p>
                            Zu Sonstigen Anlagen zählen: </p>
                        <ul>
                            <li>bankeigenes Wertpapier-Depot</li>
                            <li>Union Investment - Fondsdepot</li>
                            <li>Schwäbisch Hall - Bausparguthaben</li>
                            <li>R+V Versicherung - Rückkaufswerte bei Lebens- und Rentenversicherungen</li>

                        </ul>

                        <div style="margin-top: 30px">
                            <button type="reset" class="button grey" @click="DepotHinweis = false"
                                    style="margin-right: 10px;color: #444">
                                Schließen
                            </button>
                        </div>
                    </div>
                    <div slot="footer">
                    </div>

                </modal>

                <div class="formattedInputs darkgrey"><label>Gesamtvolumen </label>
                    <vue-numeric
                            read-only
                            currency="€"
                            currency-symbol-position="suffix"
                            separator="."
                            v-model.number="Gesamtvolumen"></vue-numeric>
                </div>

            </div>
            <div style="margin-top: 20px" class="column right">

                <h2>Einlagen <span style="font-weight: normal;font-size: 16px">(im Verhältnis zum Gesamtvolumen)
                    <svg style="width:16px;height:16px;fill:#0066b3;cursor:pointer;"
                         @click="showModalVE = true"
                         stroke-miterlimit="10"
                         color-interpolation="auto" viewBox="0 0 230.344 230.203">
                        <path d="M230.344 115.172q0 47.953-33.61 81.492-33.609 33.54-81.562 33.54-47.953 0-81.563-33.54Q0 163.125 0 115.172t33.61-81.563Q67.218 0 115.171 0q47.953 0 81.562 33.61 33.61 33.609 33.61 81.562zm-18.844 0q0-40.219-28.055-68.344-28.054-28.125-68.273-28.125-40.219 0-68.344 28.125-28.125 28.125-28.125 68.344 0 40.219 28.125 68.273Q74.953 211.5 115.172 211.5q40.219 0 68.273-28.055 28.055-28.054 28.055-68.273zm-72.703-59.344q0 9.422-7.031 15.75-7.032 6.328-16.594 6.328-9.563 0-16.594-6.328-7.031-6.328-7.031-15.75t7.031-15.75q7.031-6.328 16.594-6.328 9.562 0 16.594 6.328 7.03 6.328 7.03 15.75zm-4.36 145.406H95.767V91.547h38.671z"
                              stroke="none"/>
                    </svg>
                </span>
                </h2>

                <Bar2d :quote="Quote" :zinssatz="Zinsatz"></Bar2d>

            </div>

            <div class="konten column" style="margin-top: 20px">
                <h2>Ihre Konten bei uns</h2>
                <div class="formattedInputs grey" v-bind:class="{ lightblue: Konten.BusinessPremium>0}"><label>Business
                    Premium
                    <div class="smaller" style="font-size:12px;font-style:italic">Freibetrag: 100.000 €</div>
                </label>
                    <vue-numeric
                            :empty-value="null"
                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="Stück"
                            currency-symbol-position="suffix"
                            separator="."
                            v-on:focus="BusinessPremiumHinweis=true"
                            v-on:blur="BusinessPremiumHinweis=false"
                            v-model.number="Konten.BusinessPremium"></vue-numeric>

                </div>

                <div class="formattedInputs grey" v-bind:class="{ lightblue: Konten.Business150>0}"><label>Business 150
                    <div class="smaller" style="font-size:12px;font-style:italic">Freibetrag: 75.000 €</div>
                </label>
                    <vue-numeric
                            :empty-value="null"
                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="Stück"
                            currency-symbol-position="suffix"
                            separator="."
                            v-on:focus="Business150Hinweis=true"
                            v-on:blur="Business150Hinweis=false"
                            v-model.number="Konten.Business150"></vue-numeric>

                </div>

                <div class="formattedInputs grey" v-bind:class="{ lightblue: Konten.Business60>0}"><label>Business 60
                    <div class="smaller" style="font-size:12px;font-style:italic">Freibetrag: 50.000 €</div>
                </label>
                    <vue-numeric
                            :empty-value="null"
                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="Stück"
                            currency-symbol-position="suffix"
                            separator="."
                            v-on:focus="Business60Hinweis=true"
                            v-on:blur="Business60Hinweis=false"
                            v-model.number="Konten.Business60"></vue-numeric>
                </div>

                <div class="formattedInputs grey" v-bind:class="{ lightblue: Konten.Business20>0}"><label>Business 20
                    <div class="smaller" style="font-size:12px;font-style:italic">Freibetrag: 25.000 €</div>
                </label>
                    <vue-numeric
                            :empty-value="null"
                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="Stück"
                            currency-symbol-position="suffix"
                            separator="."
                            v-on:focus="Business20Hinweis=true"
                            v-on:blur="Business20Hinweis=false"
                            v-model.number="Konten.Business20"></vue-numeric>
                </div>

                <div class="formattedInputs grey" v-bind:class="{ lightblue: Konten.BusinessKlassik>0}"><label>Business
                    Klassik
                    <div class="smaller" style="font-size:12px;font-style:italic">Freibetrag: 25.000 €</div>
                </label>
                    <vue-numeric
                            :empty-value="null"
                            v-bind:min="0"
                            v-bind:minus="false"
                            currency="Stück"
                            currency-symbol-position="suffix"
                            separator="."
                            v-on:focus="BusinessKlassikHinweis=true"
                            v-on:blur="BusinessKlassikHinweis=false"
                            v-model.number="Konten.BusinessKlassik"></vue-numeric>
                </div>

                <div class="formattedInputs lightblue"><label>Resultierender Freibetrag</label>
                    <span>{{Freibetrag|formatNumber}} €</span>
                </div>

            </div>
            <div style="margin-top: 20px" class="column right">
                <h2>Ihr Ergebnis</h2>

                <div class="formattedInputs  "><label>Einlagen </label>
                    <span>{{Einlagen | formatNumber}} €</span>
                </div>
                <div class="formattedInputs lightblue"><label>abzgl. Freibetrag </label>
                    <span>{{Freibetrag|formatNumber}} €</span>
                </div>
                <div class="formattedInputs darkgrey"><label>anzurechnender Betrag </label>
                    <span>{{anzurechnender_Betrag|formatNumber}} €</span>
                </div>
                <div class="formattedInputs blue">
                    <label v-if="Zinsatz<=0">monatliches Verwahrentgelt <sup>(4)</sup></label>
                    <label v-if="Zinsatz>0">monatliche Gutschrift </label>
                    <span>{{Zinsbelastung|formatNumber}} €</span>
                </div>

            </div>
        </div>

        <p>Sie haben Fragen oder wünschen eine individuelle Beratung?</p>

        <button class="button" id="show-modal" @click="showModal = true">Anfrage senden</button>

        <modal v-if="showModal" @close="showModal = false">
            <h3 slot="header">Anfrage senden</h3>
            <div slot="body">
                <p>Sie haben Fragen oder wünschen eine individuelle Beratung? Nutzen Sie hier unser Formular für
                    Ihre Anfrage.</p>

                <form id="myform" @submit="Anfragen" style="margin-top: 30px">

                    <div class="formInputs grey">
                        <label>Name*:</label>
                        <input type="text" v-model="Formular.Name" style="text-align: left" required>
                    </div>

                    <div class="formInputs grey">
                        <label>E-Mail*:</label>
                        <input type="email" v-model="Formular.EMail" style="text-align: left" required>
                    </div>

                    <div class="formInputs grey">
                        <label>Telefon:</label>
                        <input type="tel" v-model="Formular.Telefon" style="text-align: left"/>
                    </div>


                    <div class="formInputs grey">
                        <label>Kontonummer:</label>
                        <input type="tel" v-model="Formular.Kontonummer" style="text-align: left"/>
                    </div>

                    <div class="formInputs grey">
                        <label>Frage*:</label>
                        <textarea v-model="Formular.Frage" required style="text-align: left;width: 90%"></textarea>
                    </div>
                    <div style="margin-top: 20px">

                        <input type="checkbox" v-model="Formular.DSE" required/> Hiermit stimme ich den
                        Datenschutzbestimmungen zu. Die Daten dieser Anfrage werden nur
                        zur Beantwortung dieser Anfrage elektronisch gespeichert.
                    </div>

                    <div style="margin-top: 30px">
                        <button type="reset" class="button grey" @click="showModal = false"
                                style="margin-right: 10px;color: #444">
                            Schließen
                        </button>

                        <button type="submit" class="button " value="Senden">
                            Senden
                        </button>
                    </div>
                    <p class="smaller">* Die Felder werden zum Absenden benötigt.</p>
                </form>
            </div>
            <div slot="footer">

            </div>

        </modal>
        <modal v-if="showModalVE" @close="showModalVE = false">
            <h3 slot="header">Unsere Verwahrentgelte<sup>(4)</sup> im Überblick:</h3>
            <div slot="body">


                <img src="./../assets/Verwahrentgelte.jpg" alt="Verwahrentgelte im Überblick">


                <p class="smaller">
                    <sub>(1)</sub> Quartalsdurchschnittswert
                    <sub>(2)</sub> Stichtagswert zum Quartalsende
                    <sub>(3)</sub> Berechnung auf Einlagen ab 25.000 EUR Gesamtguthaben und Vorhandensein VR Business
                    Konto
                    <sub>(4)</sub> Bei Vorsteuerabzugsberechtigten verstehen sich alle Entgelte zzgl. gesetzlicher
                    Mehrwertsteuer.
                </p>


                <div style="margin-top: 30px">
                    <button type="reset" class="button grey" @click="showModalVE = false"
                            style="margin-right: 10px;color: #444">
                        Schließen
                    </button>


                </div>


            </div>
            <div slot="footer">

            </div>

        </modal>


        <p class="smaller">
            <sub>(1)</sub> Quartalsdurchschnittswert
            <sub>(2)</sub> Stichtagswert zum Quartalsende
            <sub>(3)</sub> Berechnung auf Einlagen ab 25.000 EUR Gesamtguthaben und Vorhandensein VR Business Konto
            <sub>(4)</sub> Bei Vorsteuerabzugsberechtigten verstehen sich alle Entgelte zzgl. gesetzlicher
            Mehrwertsteuer.

        </p>
    </div>
</template>

<script type="text/babel">

    import Modal from "../components/Modal/Modal";
    import Bar2d from "../components/Bar2d";
    import axios from 'axios';
    import VueNumeric from 'vue-numeric'

    export default {
        name: 'Home',

        components: {Modal, Bar2d, VueNumeric},
        methods: {
            Anfragen() {
                //alert('Hier wird das Formular für die Anfrage gesendet.')
                this.loading = true;
                let daten = {
                    Formular: this.Formular,
                    Konten: this.Konten,
                    Einlagen: this.Einlagen,
                    Kredite: this.Kredite,
                    Depot: this.Depot,
                    Zinsatz: this.Zinsatz,
                    Quote: this.Quote,
                    Verwahrentgelt: this.Zinsbelastung,
                };
                axios
                    .post(process.env.VUE_APP_API_ENDPOINT + 'mailer', daten)
                    .then(response => {
                        console.log(response.data);
                        alert(response.data);
                        this.showModal = false;
                    })
                    .catch(error => {
                        console.log(error);
                        //this.errored = true
                        alert(error);
                    })
                    .finally(() => this.loading = false)

            }
        },
        data() {
            return {
                Einlagen: 0,
                Kredite: 0,
                Depot: 0,
                Konten: {
                    BusinessPremium: 0,
                    Business150: 0,
                    Business60: 0,
                    Business20: 0,
                    BusinessKlassik: 0,
                    BusinessVereineKommunenKirchenAnderkonten: 0,
                },
                Formular: {
                    Name: '',
                    EMail: '',
                    Kontonummer: '',
                    Telefon: '',
                    Frage: '',
                    DSE: '',
                },
                showModal: false,
                showModalVE: false,
                loading: false,
                EinlagenHinweis: false,
                KrediteHinweis: false,
                DepotHinweis: false,

                FreibetragHinweis: false,
                BusinessPremiumHinweis: false,
                Business150Hinweis: false,
                Business60Hinweis: false,
                Business20Hinweis: false,
                BusinessKlassikHinweis: false,
            }
        },
        computed: {
            /**
             * @return {number}
             */
            Gesamtvolumen() {
                return this.Einlagen + this.Kredite + this.Depot
            },
            /**
             * @return {number}
             */
            Quote() {
                if (this.Einlagen === 0) return 0;
                return this.Einlagen / this.Gesamtvolumen * 100
            },
            /**
             * @return {number}
             */
            Zinsatz() {
                if (this.Quote <= 25) {
                    if (this.Einlagen >= 25000)
                        return 0.1;
                    else
                        return 0;

                }
                if (this.Quote <= 50) return 0;
                if (this.Quote < 100) return -0.4;
                if (this.Quote === 100) return -0.5;
            },

            /**
             * @return {number}
             */
            Freibetrag() {
                let freibetrag = 0;

                if (this.Konten.BusinessPremium > 0) {
                    freibetrag += this.Konten.BusinessPremium * 100000;
                }

                if (this.Konten.Business150 > 0) {
                    freibetrag += this.Konten.Business150 * 75000;
                }

                if (this.Konten.Business60 > 0) {
                    freibetrag += this.Konten.Business60 * 50000;
                }

                if (this.Konten.Business20 > 0) {
                    freibetrag += this.Konten.Business20 * 25000;
                }

                if (this.Konten.BusinessKlassik > 0) {
                    freibetrag += this.Konten.BusinessKlassik * 25000;
                }

                if (this.Konten.BusinessVereineKommunenKirchenAnderkonten > 0) {
                    freibetrag += this.Konten.BusinessVereineKommunenKirchenAnderkonten * 100000;
                }
                if (freibetrag == 0) freibetrag = 25000;
                return freibetrag;
            },
            /**
             * @return {number}
             */
            anzurechnender_Betrag() {
                if (this.Einlagen - this.Freibetrag < 0) return 0;
                return this.Einlagen - this.Freibetrag;
            },
            /**
             * @return {number}
             */
            Zinsbelastung() {

                if (this.Zinsatz < 0) {
                    if (this.anzurechnender_Betrag === 0) return 0;
                    return this.anzurechnender_Betrag * this.Zinsatz / 100 / 12;
                } else {
                    return this.Einlagen * this.Zinsatz / 100 / 12;
                }
            },

        }

    }
</script>

<style lang="scss" scoped>

    p.smaller {
        font-size: 14px;
        line-height: 18px;
    }

    .columnwrapper {
        @media only screen and (min-width: 770px) {
            display: flex;
            flex-wrap: wrap;
        }
    }

    .column {
        @media only screen and (min-width: 770px) {
            flex: 1 0 50%;
            &.right {
                align-self: flex-end;
            }
        }
    }

    div.Hinweis {
        z-index: 99;
        padding: 20px;
        border-radius: 4px;
        background-color: #eee;
        margin-bottom: 10px;
        position: absolute;
        max-width: 500px;
    }

    .formattedInputs {
        label, input, span, textarea {
            padding: 5px;
            margin-bottom: 5px;
            display: inline-block;
            background-color: rgba(255, 102, 0, 1);
            width: 230px;
            color: #fff;
            border: none;
            font-size: 16px;
            line-height: 19px;
            border-radius: 6px;
            text-align: right;
            vertical-align: top;
            @media only screen and (max-width: 480px) {
                width: 160px;
                font-size: 13px;
                line-height: 15px;
            }
        }

        input, span, textarea {
            width: 110px;
            @media only screen and (max-width: 480px) {
                width: 80px;
            }


        }

        span, input {
            margin-left: 5px;


        }

        &.blue {
            label, input, span, textarea {
                background-color: #0066b3;
            }
        }

        &.grey {
            label, input, span, textarea {
                background-color: #bbbaba;
            }
        }

        &.darkgrey {
            label, input, span, textarea {
                background-color: #7f7e7e;
            }
        }

        &.lightblue {
            label, input, span, textarea {
                background-color: #268fdd;
            }
        }

    }

    .formInputs {
        label {
            padding: 5px;
            padding-left: 0;
            margin-top: 5px;
            display: block;
            background-color: transparent;
            border: none;
            font-size: 16px;
            line-height: 19px;
            vertical-align: top;
        }

        input, span, textarea {
            padding: 5px;
            margin-bottom: 5px;
            display: inline-block;
            background-color: transparent;
            width: 300px;
            @media only screen and (max-width: 480px) {
                width: 90%;
            }
            border: 1px solid rgba(255, 102, 0, 1);
            font-size: 16px;
            line-height: 19px;
            border-radius: 6px;
            text-align: right;
            vertical-align: top;
        }

        textarea {
            height: 160px;
        }

        &.lightblue {
            input, span, textarea {
                border: 1px solid #268fdd;
            }
        }

        &.blue {
            input, span, textarea {
                border: 1px solid #0066b3;
            }
        }

        &.grey {
            input, span, textarea {
                border: 1px solid #bbbaba;
            }
        }

        &.darkgrey {
            input, span, textarea {
                border: 1px solid #7f7e7e;
            }
        }
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    .slide-fade-leave-active {
        transition: all .2s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        transform: translateX(10px);
        opacity: 0;

    }
</style>
